(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["complete-the-look"] && !Shopify.designMode) return;
  try {
    (function() {
    function formatMoney(cents) {
      if (window.theme && theme.Currency && theme.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.moneyFormat);
      }

      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }

      return (cents / 100).toFixed(2);
    }

    function getSizedImageUrl(src) {
      if (window.theme && theme.Images && theme.Images.getSizedImageUrl) {
        return theme.Images.getSizedImageUrl(src, '520x');
      }

      return src;
    }

    function getProductJson(widget) {
      var sectionId = widget.getAttribute('data-section-id');
      var jsonElement = sectionId ? document.getElementById('ProductJson-' + sectionId) : null;

      if (!jsonElement) {
        return null;
      }

      try {
        return JSON.parse(jsonElement.textContent);
      } catch (error) {
        return null;
      }
    }

    function findVariantById(productJson, variantId) {
      if (!productJson || !productJson.variants) {
        return null;
      }

      for (var index = 0; index < productJson.variants.length; index += 1) {
        if (String(productJson.variants[index].id) === String(variantId)) {
          return productJson.variants[index];
        }
      }

      return null;
    }

    function setPickerLabel(widget, role, label, variantId) {
      var picker = widget.querySelector('[data-complete-look-picker="' + role + '"]');

      if (!picker) {
        return;
      }

      var labelElement = picker.querySelector('[data-complete-look-selected-text]');
      var select = picker.querySelector('[data-complete-look-select]');

      if (labelElement) {
        labelElement.textContent = label;
      }

      if (select && variantId) {
        select.value = variantId;
      }
    }

    function setMainPickerFromVariant(widget, variant) {
      if (!variant) {
        return;
      }

      setPickerLabel(widget, 'main', variant.title + ' - ' + formatMoney(variant.price), variant.id);
    }

    function closePickers(exceptPicker) {
      var pickers = document.querySelectorAll('[data-complete-look-picker]');

      for (var index = 0; index < pickers.length; index += 1) {
        if (pickers[index] !== exceptPicker) {
          pickers[index].classList.remove('is-open');
          var selected = pickers[index].querySelector('[data-complete-look-selected]');

          if (selected) {
            selected.setAttribute('aria-expanded', 'false');
          }
        }
      }
    }

    function syncMainProductToVariant(widget, variant) {
      var section = widget.closest('[data-section-type="product"]');

      if (!section || !variant) {
        return;
      }

      if (window.jQuery) {
        var $section = jQuery(section);

        $section.find('.single-option-selector').each(function(index) {
          var optionValue = variant['option' + (index + 1)];

          if (!optionValue) {
            return;
          }

          jQuery(this).val(optionValue).trigger('change');
          $section.find('.swatch[data-option-index="' + index + '"] .swatchInput').filter(function() {
            return this.value === optionValue;
          }).prop('checked', true);
        });

        $section.find('.productForm select[name="id"], .productForm input[name="id"]').val(variant.id).trigger('change');
      } else {
        var selectors = section.querySelectorAll('.single-option-selector');

        for (var index = 0; index < selectors.length; index += 1) {
          var optionValue = variant['option' + (index + 1)];

          if (optionValue) {
            selectors[index].value = optionValue;
            selectors[index].dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    }

    function getSelectedMainVariant(widget) {
      var section = widget.closest('[data-section-type="product"]');
      var selector = section ? section.querySelector('.productForm select[name="id"], .productForm input[name="id"]') : null;
      var selectedId = selector ? selector.value : widget.getAttribute('data-main-variant-id');
      var productJson = getProductJson(widget);

      var selectedVariant = findVariantById(productJson, selectedId);

      if (selectedVariant) {
        return selectedVariant;
      }

      return {
        id: selectedId,
        price: parseInt(widget.getAttribute('data-main-variant-price'), 10),
        available: true
      };
    }

    function updateWidget(widget) {
      var mainVariant = getSelectedMainVariant(widget);
      var complementaryPrice = parseInt(widget.getAttribute('data-complementary-variant-price'), 10);
      var total = widget.querySelector('[data-complete-look-total]');
      var button = widget.querySelector('[data-complete-look-add]');

      if (mainVariant && mainVariant.id) {
        widget.setAttribute('data-main-variant-id', mainVariant.id);
        setMainPickerFromVariant(widget, mainVariant);
      }

      if (mainVariant && mainVariant.featured_image && mainVariant.featured_image.src) {
        var mainImage = widget.querySelector('.complete-look__image-link:first-child img');

        if (mainImage) {
          mainImage.src = getSizedImageUrl(mainVariant.featured_image.src);
          mainImage.removeAttribute('srcset');
        }
      }

      if (mainVariant && !isNaN(mainVariant.price) && !isNaN(complementaryPrice) && total) {
        total.innerHTML = formatMoney(mainVariant.price + complementaryPrice);
      }

      if (!button) {
        return;
      }

      if (widget.getAttribute('data-complementary-available') !== 'true') {
        button.setAttribute('disabled', 'disabled');
      } else if (mainVariant && mainVariant.available === false) {
        button.setAttribute('disabled', 'disabled');
      } else if (mainVariant && mainVariant.available !== false) {
        button.removeAttribute('disabled');
      }
    }

    function selectMainVariant(widget, option) {
      var variantId = option.getAttribute('data-variant-id');
      var label = option.getAttribute('data-variant-label');
      var productJson = getProductJson(widget);
      var variant = findVariantById(productJson, variantId);
      var button = widget.querySelector('[data-complete-look-add]');

      setPickerLabel(widget, 'main', label, variantId);

      if (!variant) {
        if (button) {
          button.setAttribute('disabled', 'disabled');
        }

        return;
      }

      widget.setAttribute('data-main-variant-id', variant.id);
      syncMainProductToVariant(widget, variant);
      updateWidget(widget);
    }

    function selectComplementaryVariant(widget, option) {
      var variantId = option.getAttribute('data-variant-id');
      var label = option.getAttribute('data-variant-label');
      var button = widget.querySelector('[data-complete-look-add]');

      setPickerLabel(widget, 'complementary', label, variantId);

      if (!variantId) {
        widget.setAttribute('data-complementary-available', 'false');

        if (button) {
          button.setAttribute('disabled', 'disabled');
        }

        return;
      }

      widget.setAttribute('data-complementary-variant-id', variantId);
      widget.setAttribute('data-complementary-variant-price', option.getAttribute('data-variant-price'));
      widget.setAttribute('data-complementary-available', option.getAttribute('data-variant-available') || 'true');

      var image = widget.querySelector('[data-complete-look-product="complementary"] img');
      var imageUrl = option.getAttribute('data-variant-image');

      if (image && imageUrl) {
        image.src = imageUrl;
        image.removeAttribute('srcset');
      }

      updateWidget(widget);
    }

    function openCart() {
      if (window.jQuery) {
        jQuery('body').removeClass('loading showOverly');
        jQuery('.header-cart').trigger('click');
      } else {
        document.body.classList.remove('loading', 'showOverly');
      }
    }

    function showError(message) {
      if (window.jQuery) {
        jQuery('body').removeClass('loading').addClass('showOverly');
        jQuery('.error-message').text(message);
        jQuery('#errorDrawer').fadeIn(500);
      } else {
        document.body.classList.remove('loading');
      }
    }

    function addWithFetch(items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      }).then(function(response) {
        if (!response.ok) {
          return response.json().then(function(error) {
            throw new Error(error.description || error.message);
          });
        }

        return response.json();
      });
    }

    document.addEventListener('change', function(event) {
      if (!event.target.matches('.productForm select[name="id"], .productForm input[name="id"]')) {
        return;
      }

      var section = event.target.closest('[data-section-type="product"]');
      var widgets = section ? section.querySelectorAll('[data-complete-look]') : [];

      for (var index = 0; index < widgets.length; index += 1) {
        updateWidget(widgets[index]);
      }
    });

    document.addEventListener('click', function(event) {
      var selected = event.target.closest('[data-complete-look-selected]');

      if (selected) {
        event.preventDefault();

        var picker = selected.closest('[data-complete-look-picker]');
        var isOpen = picker.classList.contains('is-open');

        closePickers(picker);
        picker.classList.toggle('is-open', !isOpen);
        selected.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        return;
      }

      var option = event.target.closest('[data-complete-look-option]');

      if (option) {
        event.preventDefault();

        var widget = option.closest('[data-complete-look]');
        var role = option.getAttribute('data-product-role');
        var picker = option.closest('[data-complete-look-picker]');

        if (picker) {
          picker.classList.remove('is-open');
          var pickerButton = picker.querySelector('[data-complete-look-selected]');

          if (pickerButton) {
            pickerButton.setAttribute('aria-expanded', 'false');
          }
        }

        if (role === 'main') {
          selectMainVariant(widget, option);
        } else if (role === 'complementary') {
          selectComplementaryVariant(widget, option);
        }

        return;
      }

      if (!event.target.closest('[data-complete-look-picker]')) {
        closePickers();
      }
    });

    document.addEventListener('click', function(event) {
      var button = event.target.closest('[data-complete-look-add]');

      if (!button) {
        return;
      }

      event.preventDefault();

      if (button.disabled) {
        return;
      }

      var widget = button.closest('[data-complete-look]');
      var mainVariant = getSelectedMainVariant(widget);
      var complementaryVariantId = widget.getAttribute('data-complementary-variant-id');

      if (!mainVariant || !mainVariant.id || !complementaryVariantId) {
        return;
      }

      var items = [
        { id: Number(mainVariant.id), quantity: 1 },
        { id: Number(complementaryVariantId), quantity: 1 }
      ];

      document.body.classList.add('loading');

      if (window.CartJS && CartJS.addItems) {
        CartJS.addItems(items, {
          success: function() {
            setTimeout(openCart, 600);
          },
          error: function(jqXHR) {
            var message = '';

            try {
              message = jqXHR && jqXHR.responseText ? JSON.parse(jqXHR.responseText).description : '';
            } catch (error) {
              message = '';
            }

            showError(message);
          }
        });
      } else {
        addWithFetch(items).then(openCart).catch(function(error) {
          showError(error.message);
        });
      }
    });

    document.addEventListener('DOMContentLoaded', function() {
      var widgets = document.querySelectorAll('[data-complete-look]');

      for (var index = 0; index < widgets.length; index += 1) {
        updateWidget(widgets[index]);
      }

      if (window.jQuery) {
        jQuery(document).on('variantChange.completeLook', '[data-section-type="product"]', function(event) {
          var widgets = this.querySelectorAll('[data-complete-look]');

          for (var index = 0; index < widgets.length; index += 1) {
            setMainPickerFromVariant(widgets[index], event.variant);
            updateWidget(widgets[index]);
          }
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
